<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  const user = localStorage.getItem("us");

  const API_END_POINT = END_POINT;
  const gettotal_api_url = API_END_POINT + "gettotal.php";
  const getperson_api_url = API_END_POINT + "getperson.php";

  const get_payment_response_api_url =
    API_END_POINT + "getpaymentconfirmation.php";

  const get_payment_failed_response_api_url =
    API_END_POINT + "getpayment_failed_confirmation.php";

  let my_data,
    totalprice,
    payment_status,
    new_order_id,
    rzp1,
    response_id = "";
  let Name,
    phonenumber,
    address,
    state,
    pincode = "";
  let final_address = "";
  let user_name,
    user_phone,
    user_address,
    user_pin = "";

  let payment_page_replace =
    "You Closed the payment , page will Reload in 2 Seconds , Please wait";

  onMount(() => {
    window.scrollTo(0, 0);

    if (user === null || user === "") {
      navigate("/login");
    }

    get_my_total();
    get_user();
  });

  async function get_my_total() {
    const get_total_response = await fetch(gettotal_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user }),
    });
    const get_total_response_data = await get_total_response.json();
    if (
      get_total_response_data[0] == null &&
      get_total_response_data[1] == null
    ) {
      window.location.replace("cart");
    } else {
      totalprice = get_total_response_data[0].final_total;
      new_order_id = get_total_response_data[1].new_order_id;
    }
    // console.log(new_order_id);

    if (totalprice) {
      var rzb_button = document.getElementById("rzp-button1");
      rzb_button.style.display = "block";
    }
  }

  async function get_user() {
    const get_person_response = await fetch(getperson_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user }),
    });
    const preson_data = await get_person_response.json();
    my_data = preson_data[0];
    Name = my_data.Name;
    phonenumber = my_data.phonenumber;
    address = my_data.address;
    state = my_data.state;
    pincode = my_data.user_pincode;

    final_address = address + "/n" + state + "/n" + pincode;
    // console.log(final_address);
  }

  function DHide_paysuccess_Modal() {
    // to hide delete modal
    var dmodalInstance = null;
    var dmodelElem = document.getElementById("payment_success_modal");
    dmodalInstance = bootstrap.Modal.getInstance(dmodelElem);
    dmodalInstance.hide();
    navigate("/orders");
  }

  function DHide_payfail_Modal() {
    // to hide delete modal
    var fmodalInstance = null;
    var fmodelElem = document.getElementById("payment_failed_modal");
    fmodalInstance = bootstrap.Modal.getInstance(fmodelElem);
    fmodalInstance.hide();
    if (
      payment_page_replace ==
      "You Closed the payment , page will Reload in 2 Seconds , Please wait"
    ) {
      window.location.reload();
    } else {
      var newlocation = "failedpayments/" + response_id;
      window.location.replace(newlocation);
    }
  }

  function razorpayinitiate() {
    user_name = document.getElementById("delivery_name").value;
    user_phone = document.getElementById("delivery_phone").value;
    user_address = document.getElementById("delivery_address").value.trim();
    user_pin = document.getElementById("delivery_pin").value;

    const new_user_address = user_address + "," + user_pin;

    var options = {
      key: "rzp_live_GXffdgQ8bj7aNU",
      amount: totalprice, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Veeran Fashions",
      description: "new payment by" + Name,
      image: "./logo_512.png",
      order_id: new_order_id,
      handler: async function (response) {
        const get_payment_response = await fetch(get_payment_response_api_url, {
          method: "POST",
          body: JSON.stringify({
            uid: user,
            address: new_user_address,
            additional_phone: user_phone,
            payment_id: response.razorpay_payment_id,
            order_id: response.razorpay_order_id,
            payment_signature: response.razorpay_signature,
          }),
        });
        const get_payment_response_data = await get_payment_response.json();
        payment_status = get_payment_response_data.final_payment_response;
        // alert(payment_status);
        // console.log(payment_status);
        if (payment_status == "successful") {
          let Paysuccess_Modal = new bootstrap.Modal(
            document.getElementById("payment_success_modal"),
            {}
          );
          Paysuccess_Modal.show();
          setTimeout(DHide_paysuccess_Modal, 5000);
        }
      },
      prefill: {
        name: Name,
        contact: phonenumber,
      },
      notes: {
        address: new_user_address,
      },
      notify: {
        sms: true,
        email: true,
      },
      theme: {
        color: "#151725",
      },
      reminder_enable: true,
      method: {
        netbanking: "0",
        card: "1",
        upi: "1",
        wallet: "0",
        emi: "0",
        paylater: "0",
        cardless_emi: "0",
        bank_transfer: "0",
        emandate: "0",
      },
    };
    options.theme.image_padding = false;
    options.modal = {
      ondismiss: function () {
        if (
          payment_page_replace ==
          "The Page will Reload in 2 Seconds , Please wait"
        ) {
          let Payfailed_Modal = new bootstrap.Modal(
            document.getElementById("payment_failed_modal"),
            {}
          );
          Payfailed_Modal.show();
          setTimeout(DHide_payfail_Modal, 2000);
        } else {
          let Payfailed_Modal = new bootstrap.Modal(
            document.getElementById("payment_failed_modal"),
            {}
          );
          Payfailed_Modal.show();
          setTimeout(DHide_payfail_Modal, 10000);
        }
      },
      // Boolean indicating whether pressing escape key
      // should close the checkout form. (default: true)
      escape: false,
      // Boolean indicating whether clicking translucent blank
      // space outside checkout form should close the form. (default: false)
      backdropclose: false,
    };
    rzp1 = new Razorpay(options);
    rzp1.on("payment.failed", async function (response) {
      payment_page_replace = response.error.reason;
      const get_payment_failed_response = await fetch(
        get_payment_failed_response_api_url,
        {
          method: "POST",
          body: JSON.stringify({
            uid: user,
            response_code: response.error.code,
            response_description: response.error.description,
            response_source: response.error.source,
            response_step: response.error.step,
            response_reason: response.error.reason,
            response_order_id: response.error.metadata.order_id,
            response_payment_id: response.error.metadata.payment_id,
          }),
        }
      );
      const get_payment_failed_response_data =
        await get_payment_failed_response.json();
      const failed_payment_status =
        get_payment_failed_response_data.insert_status;

      response_id = response.error.metadata.order_id;

      if (failed_payment_status === "success") {
        payment_page_replace =
          "Payment was unsuccessful due to a temporary issue. \n If amount got deducted, it will be refunded within 5-7 working days. \n\n At any time go to Settings -> Failed Payments to get Failed Payment info. \n\n Redirecting you in 10 seconds \n\n Please wait...";
        rzp1.close();
      } else {
        alert(
          get_payment_failed_response_data.insert_status +
            "close the app and try again later"
        );
      }
    });
    rzp1.open();
  }
</script>

<svelte:head>
  <title>Checkout | Veeranfashions Home</title>
  <!-- Razorpay -->
  <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h2 class="title text-center">Checkout</h2>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="wishlist"
                    area-label="wishlist"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-heart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <div class="billing-info section-gap-top-25">
    <div class="container px-0 glass">
      <div class="billing-information-card">
        <span class="billing-information-title">Billing Information</span>
        <ul class="billing-information-lists">
          <li class="billing-information-list">
            <span> Name</span>
            <span
              ><input
                type="text"
                value={Name}
                class="form-control"
                id="delivery_name"
              /></span
            >
          </li>
          <li class="billing-information-list">
            <span> Contact</span>
            <span
              ><input
                type="tel"
                value={phonenumber}
                class="form-control"
                id="delivery_phone"
              /></span
            >
          </li>
          <li class="billing-information-list">
            <span> Address</span>
            <span
              ><textarea
                class="form-control"
                rows="5"
                value={address}
                id="delivery_address"
              /></span
            >
          </li>
          <li class="billing-information-list">
            <span> Pincode</span>
            <span
              ><input
                type="number"
                value={pincode}
                class="form-control"
                id="delivery_pin"
              /></span
            >
          </li>
        </ul>

        <div class="shipping-method-lists">
          <p class="text-colored" hidden>
            2% of total amount will be added as Delivery amount to total payment
            amount.
          </p>
          <br />
          <b style="padding-top: 5px;"
          hidden>Delivery Available only inside Tamilnadu.</b
          >
        </div>

        <div class="payment-card">
          <span class="total-price"
            >Total Price : <span class="counter">₹ {totalprice}</span></span
          >

          <div class="mx-2 price-n-cart">
            <button
              class="btn cart"
              type="button"
              id="rzp-button1"
              on:click={razorpayinitiate}
              style="display: none;">Pay & ordernow</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal slide-top" tabindex="-1" id="payment_success_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>
            Payment Received & order placed Successfully... <br /> Redirecting you
            please wait..
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal slide-top" id="payment_failed_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>
            <b>{payment_page_replace}</b>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          
          <Link to="/cart" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-cart-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
              />
            </svg>
            <br />
            <h6>Cart</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
